(function() {
  // ── CART COUNT UPDATE ──
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartCount = document.querySelector('.cart-count');
        if (!cartCount) return;
        if (cart.item_count > 0) {
          cartCount.textContent = cart.item_count;
          cartCount.style.display = 'inline-flex';
        } else {
          cartCount.style.display = 'none';
        }
      })
      .catch(err => console.error('Cart update failed:', err));
  }

  updateCartCount();

  // ── CART DRAWER ──
  const drawer = document.getElementById('cart-drawer');
  const drawerOverlay = document.getElementById('cart-drawer-overlay');

  // Uses the store's money format from Shopify settings (multi-currency safe)
  const moneyFormat = (drawer && drawer.dataset.moneyFormat) || '${{amount}}';
  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','));
  }

  function renderDrawer(cart) {
    if (!drawer) return;

    const countEl = drawer.querySelector('[data-drawer-count]');
    if (countEl) countEl.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';

    const subtotalEl = drawer.querySelector('[data-drawer-subtotal]');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    // Free shipping progress
    const threshold = parseInt(drawer.dataset.threshold || '0', 10) * 100;
    const shipbar = drawer.querySelector('[data-drawer-shipbar]');
    if (shipbar && threshold > 0 && cart.item_count > 0) {
      shipbar.style.display = 'block';
      const label = shipbar.querySelector('[data-drawer-shipbar-label]');
      const fill = shipbar.querySelector('[data-drawer-shipbar-fill]');
      const pct = Math.min(100, Math.round(cart.total_price * 100 / threshold));
      if (fill) fill.style.width = pct + '%';
      if (label) {
        label.innerHTML = cart.total_price >= threshold
          ? '🎉 <strong>You\'ve unlocked FREE shipping!</strong>'
          : 'You\'re <strong>' + formatMoney(threshold - cart.total_price) + '</strong> away from <strong>FREE shipping</strong> 🚚';
      }
    } else if (shipbar) {
      shipbar.style.display = 'none';
    }

    const itemsEl = drawer.querySelector('[data-drawer-items]');
    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML =
        '<div class="cart-drawer-empty">' +
        '<span class="cart-drawer-empty-emoji">🫥</span>' +
        '<p>Your cart is empty.</p>' +
        '<p class="cart-drawer-empty-sub">Time to become a figure!</p>' +
        '</div>';
      return;
    }

    itemsEl.innerHTML = cart.items.map((item, i) => {
      const img = item.image
        ? '<img src="' + item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=240" alt="" loading="lazy">'
        : '';
      const variant = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<span class="cart-drawer-item-variant">' + item.variant_title + '</span>' : '';
      const hasPhoto = item.properties && Object.keys(item.properties).some(k => item.properties[k]);
      return (
        '<div class="cart-drawer-item">' +
          '<a href="' + item.url + '" class="cart-drawer-item-img">' + img + '</a>' +
          '<div class="cart-drawer-item-info">' +
            '<a href="' + item.url + '" class="cart-drawer-item-name">' + item.product_title + '</a>' +
            variant +
            (hasPhoto ? '<span class="cart-drawer-item-photo">📸 Photo attached ✓</span>' : '') +
            '<div class="cart-drawer-item-row">' +
              '<div class="cart-drawer-qty">' +
                '<button type="button" data-drawer-qty="' + (i + 1) + ':' + (item.quantity - 1) + '" aria-label="Decrease quantity">−</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" data-drawer-qty="' + (i + 1) + ':' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<span class="cart-drawer-item-price">' + formatMoney(item.final_line_price) + '</span>' +
            '</div>' +
          '</div>' +
        '</div>'
      );
    }).join('');
  }

  function openDrawer() {
    if (!drawer) { window.location.href = '/cart'; return; }
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        renderDrawer(cart);
        drawer.classList.add('open');
        drawer.setAttribute('aria-hidden', 'false');
        if (drawerOverlay) drawerOverlay.classList.add('open');
        document.body.classList.add('drawer-open');
      })
      .catch(() => { window.location.href = '/cart'; });
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    if (drawerOverlay) drawerOverlay.classList.remove('open');
    document.body.classList.remove('drawer-open');
  }

  window.FiguitoonCart = { open: openDrawer, close: closeDrawer };

  const navCart = document.querySelector('.nav-cart');
  if (navCart && drawer) {
    navCart.addEventListener('click', function(e) {
      e.preventDefault();
      openDrawer();
    });
  }
  const drawerClose = document.getElementById('cart-drawer-close');
  if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
  if (drawerOverlay) drawerOverlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });

  // Quantity changes inside the drawer (event delegation)
  if (drawer) {
    drawer.addEventListener('click', function(e) {
      const btn = e.target.closest('[data-drawer-qty]');
      if (!btn) return;
      const [line, quantity] = btn.dataset.drawerQty.split(':').map(Number);
      btn.disabled = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: Math.max(0, quantity) })
      })
        .then(r => r.json())
        .then(cart => { renderDrawer(cart); updateCartCount(); })
        .catch(() => { btn.disabled = false; });
    });
  }

  // ── CONFETTI: FULL-SCREEN CELEBRATION ──
  const CONFETTI_COLORS = ['#7B2FBE', '#5C1E94', '#9D4EE8', '#C99AF0', '#FFD9F2', '#FFC93C', '#ffffff'];

  function spawnConfettiPiece(x, y, vx, vy) {
    const p = document.createElement('span');
    p.className = 'confetti-piece';
    const size = 7 + Math.random() * 9;
    p.style.width = size + 'px';
    p.style.height = (Math.random() > 0.5 ? size : size * 0.45) + 'px';
    p.style.left = x + 'px';
    p.style.top = y + 'px';
    p.style.background = CONFETTI_COLORS[Math.floor(Math.random() * CONFETTI_COLORS.length)];
    if (Math.random() > 0.66) p.style.borderRadius = '50%';
    document.body.appendChild(p);

    const rot = (Math.random() - 0.5) * 1080;
    const fall = window.innerHeight - y + 60;
    const drift = vx + (Math.random() - 0.5) * 80;
    const duration = 1600 + Math.random() * 1200;

    const anim = p.animate([
      { transform: 'translate(0, 0) rotate(0deg)', opacity: 1 },
      { transform: 'translate(' + (drift * 0.6) + 'px, ' + vy + 'px) rotate(' + (rot * 0.4) + 'deg)', opacity: 1, offset: 0.25 },
      { transform: 'translate(' + drift + 'px, ' + fall + 'px) rotate(' + rot + 'deg)', opacity: 0.9 }
    ], { duration: duration, easing: 'cubic-bezier(0.22, 0.61, 0.36, 1)' });
    anim.onfinish = () => p.remove();
  }

  window.figuiConfetti = function(el) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const w = window.innerWidth;

    // Burst 1: explosion from the button
    if (el) {
      const rect = el.getBoundingClientRect();
      const cx = rect.left + rect.width / 2;
      const cy = rect.top + rect.height / 2;
      for (let i = 0; i < 30; i++) {
        const angle = Math.random() * Math.PI * 2;
        const power = 120 + Math.random() * 260;
        spawnConfettiPiece(cx, cy, Math.cos(angle) * power, Math.sin(angle) * power * 0.6 - 180);
      }
    }

    // Burst 2 & 3: cannons from the bottom corners, across the whole page
    [[0, 1], [w, -1]].forEach(([x, dir]) => {
      for (let i = 0; i < 25; i++) {
        spawnConfettiPiece(
          x + dir * Math.random() * 40,
          window.innerHeight - 20,
          dir * (80 + Math.random() * w * 0.45),
          -(window.innerHeight * (0.45 + Math.random() * 0.45))
        );
      }
    });
  };

  // ── INFINITE CAROUSELS ──
  // Duplicate items once for a seamless -50% translate loop
  document.querySelectorAll('[data-infinite-carousel]').forEach(track => {
    if (track.children.length === 0) return;
    Array.from(track.children).forEach(item => {
      track.appendChild(item.cloneNode(true));
    });
  });

  // Legacy id support (home carousel)
  const carouselTrack = document.getElementById('carousel-track');
  if (carouselTrack && !carouselTrack.hasAttribute('data-infinite-carousel') && carouselTrack.children.length > 0) {
    Array.from(carouselTrack.children).forEach(item => {
      carouselTrack.appendChild(item.cloneNode(true));
    });
  }

  // ── SCROLL REVEAL ──
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduceMotion && 'IntersectionObserver' in window) {
    const revealTargets = document.querySelectorAll(
      '.home-grid, .how-it-works, .live-now, .gift-banner, .community, .faq, .newsletter, .related-products-section'
    );
    const revealObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    revealTargets.forEach(el => {
      el.classList.add('reveal');
      revealObserver.observe(el);
    });

    // Cards get a staggered entrance inside their grids
    document.querySelectorAll('.home-grid, .products-grid, .how-steps, .community-grid').forEach(grid => {
      Array.from(grid.children).forEach((card, i) => {
        card.classList.add('reveal');
        card.style.transitionDelay = Math.min(i * 70, 420) + 'ms';
        revealObserver.observe(card);
      });
    });
  }

  // ── FIGUITOON EYES: pupils follow the cursor ──
  const eyes = document.querySelectorAll('.fig-eye');
  if (eyes.length > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    let mx = -1, my = -1, ticking = false;
    function movePupils() {
      ticking = false;
      eyes.forEach(eye => {
        const r = eye.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        const cx = r.left + r.width / 2;
        const cy = r.top + r.height / 2;
        const angle = Math.atan2(my - cy, mx - cx);
        const max = r.width * 0.18;
        const pupil = eye.firstElementChild;
        if (pupil) {
          pupil.style.transform =
            'translate(' + (Math.cos(angle) * max) + 'px, ' + (Math.sin(angle) * max) + 'px)';
        }
      });
    }
    document.addEventListener('mousemove', e => {
      mx = e.clientX; my = e.clientY;
      if (!ticking) { ticking = true; requestAnimationFrame(movePupils); }
    }, { passive: true });
  }

  // ── FIGUITOON PET: eyes that scroll with you (subtle by design) ──
  const pet = document.getElementById('fig-pet');
  if (pet) {
    // Only appears after you scroll past the hero (the hero already has eyes),
    // so it never doubles up or saturates the first screen.
    let lastY = window.scrollY;
    function petVisibility() {
      pet.classList.toggle('show', window.scrollY > 500);
    }
    petVisibility();

    // On scroll, glance in the scroll direction (nice on touch, where there's no cursor)
    let glanceTimer;
    window.addEventListener('scroll', () => {
      petVisibility();
      const dir = window.scrollY > lastY ? 1 : -1;
      lastY = window.scrollY;
      pet.querySelectorAll('.fig-pupil').forEach(p => {
        p.style.transform = 'translate(0, ' + dir * 4 + 'px)';
      });
      clearTimeout(glanceTimer);
      glanceTimer = setTimeout(() => {
        pet.querySelectorAll('.fig-pupil').forEach(p => { p.style.transform = ''; });
      }, 450);
    }, { passive: true });

    // Click = a happy little wiggle; on Home, then off to the custom-request product
    pet.addEventListener('click', () => {
      pet.classList.remove('happy');
      void pet.offsetWidth; // restart animation
      pet.classList.add('happy');

      const requestUrl = pet.dataset.requestUrl;
      if (requestUrl) {
        setTimeout(() => { window.location.href = requestUrl; }, 350);
      }
    });
  }

  // ── NEWSLETTER FORM FEEDBACK ──
  const newsletterForm = document.querySelector('.newsletter-form');
  if (newsletterForm && window.location.search.includes('customer_posted=true')) {
    const success = document.querySelector('.newsletter-success');
    if (success) {
      newsletterForm.style.display = 'none';
      success.style.display = 'block';
    }
  }
})();
